import { MetricTile } from 'src/components/Metrics';
import { Content } from 'src/contexts/ContentContext';
import { ContentId } from 'src/utils/constants/contentId';
import { InventorySummaryListingMetricsDisplayStrings } from 'src/utils/ticketMetricUtils';

import * as styles from './InventorySummaryWidgets.css';

export const SalesAndMarginDisplay = ({
  formattedTotalMetrics,
}: {
  formattedTotalMetrics:
    | InventorySummaryListingMetricsDisplayStrings
    | undefined
    | null;
}) => {
  return (
    <MetricTile.Root className={styles.metric}>
      <MetricTile.Title isCompact>
        <Content id={ContentId.SalesAndMargin} />
      </MetricTile.Title>
      <div className={styles.metricWithVisualContainer}>
        <MetricTile.CircleProgressBar
          size={48}
          value={(formattedTotalMetrics?.totalGrossMargin ?? 0) * 100}
        >
          {formattedTotalMetrics?.formattedTotalGrossMargin}
        </MetricTile.CircleProgressBar>
        <MetricTile.Metric
          isCompact
          showLoadingPlaceholders={!formattedTotalMetrics}
        >
          {formattedTotalMetrics?.formattedTotalNetProceeds}
        </MetricTile.Metric>
      </div>
    </MetricTile.Root>
  );
};
